<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <PopupIntroCModal
        :response="content"
        :preTestScore="preTestScore"
        :isAddQueueShow="true"
        :CheckWidth="CheckWidth"
        :checkAnswer="checkAnswer"
        :point="point"
        :checkText="checkText"
        @funcRoute="funcRoute"
      />
    </template>
  </div>
</template>
<script>
import '../../../assets/scss/_chineseStyle.scss';
import '../../../assets/scss/_chineseModalCustom.scss';
import {mapGetters} from 'vuex';
import PopupIntroCModal from './components/PopupIntroCModal.vue';
import LoadingMDL from '../../../components/loading/LoadingMDL';

export default {
  components: {PopupIntroCModal, LoadingMDL},
  name: 'LKT01',
  data() {
    return {
      point: null,
      code: '',
      lang: '',
      content: {},
      checkAnswer: null,
      CheckWidth: window.innerWidth.toString(),
      preTestScore: null,
      courseSection: '',
      startTime: '',
      courseCode: '',
      result: {},
      checkText: false,
      loading: true,
      navigate: {},
      v3Data: {},
      lessonDone: false,
      nextPath: null,
    };
  },

  computed: {
    ...mapGetters({
      isTestOpen: 'template/getTestStatus',
      getTemplatev3: 'v3/getTemplates',
      saveContentStatusv4: 'v4-data/saveContentStatusv4',
    }),
  },

  watch: {
    isTestOpen: function (val) {
      if (val == false) {
        // this.$router.push('/HP01/1');
      }
    },
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      const template = val.templates[0];
      this.content = template;
      this.navigate = template.navigate;

      if (!template.enable) {
        const pathFormat = template.navigate.close.action.split('-');
        alert('Access denied!');
        this.$router.push(`/v4/${pathFormat[0]}/${pathFormat[1]}`);
      }
      // if (val.codeItem === 'LKT01-80') {
      //   this.checkAnswer = true;
      // }
      // if (val.codeItem === 'LKT01-13') {
      //   //for show text
      //   this.checkAnswer = true;
      // }
      this.checkAnswer = this.$store.state.v3.checkingResult;

      //stamp
      this.$store.commit('v3/stampMainCodeItem', val.codeItem);

      //reset checking Result

      this.$store.commit('v3/v3CheckingResultTrue');

      //stamp v4CurrentMainCodeItem

      this.$store.dispatch('v4/checkCurrentMainCode', this.v3Data);

      this.loading = false;
    },
    saveContentStatusv4: function (val) {
      console.log(val, 'LKT01 Watcher Call');
      if (this.nextPath) {
        this.loading = true;

        const splitPath = this.nextPath.split('-');
        const onNext = `/v4/${splitPath[0]}/${splitPath[1]}`;
        //to LTK 01
        this.$router.push(onNext);
      }
    },
    '$route.params.id'() {
      this.onLoad();
    },
  },

  mounted() {
    this.onLoad();
  },

  created() {},

  beforeDestroy() {},
  methods: {
    onLoad() {
      this.loading = true;

      this.lang = this.$store.state.language.language;
      this.pageCode = `LKT01-` + this.$route.params.id;

      //get score
      // if (this.pageCode === 'LKT01-77') {
      //   let score =
      //     this.$store.getters['template/getDisplayScore'].totalQuizScore;
      //   this.preTestScore = score;
      // }

      // if (
      //   this.pageCode === 'LKT01-24' ||
      //   this.pageCode == 'LKT01-65' ||
      //   this.pageCode == 'LKT01-66'
      // ) {
      //   this.point = this.$store.getters['necessary/getTmpScore'];
      // }
      // console.log(this.point, 'point');
      // console.log(this.pageCode, 'page Code');

      if (this.pageCode == 'LKT01-65' || this.pageCode == 'LKT01-66') {
        this.checkText = true;
        // this.point = 0;
      }

      //set post
      // if (this.pageCode === 'LKT01-78') {
      //   this.$store.commit('necessary/setMode', {mode: true, type: 'POSTTEST'});
      // }

      // //for result matrix
      // let result = this.$store.getters['template/getCheckAnswerResult'];

      // console.log(result, 'result');
      // // console.log(this.checkAnswer);

      // if (result == undefined || result.userAnswer == undefined) {
      //   console.log('check again');

      //   this.checkAnswer = this.$store.getters['template/getCheckingResult'];
      // } else {
      //   if (result.userAnswer.length == 0) {
      //     console.log('no length');

      //     this.checkAnswer = this.$store.getters['template/getCheckingResult'];
      //   } else {
      //     this.checkAnswer = result.userAnswer[0].status;
      //   }
      // }

      //new check result

      // console.log(this.checkAnswer, 'check answer');

      this.courseCode = this.$store.state.necessary.learningCourse;

      const contentId = `LKT01-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);

      // this.checkLastLesson();
    },
    checkLastLesson() {
      //compare codeItem
      const currentCode = this.v3Data.codeItem;
      const lastCode = this.v3Data.lastContent;
      //lesson done true if current === last
      if (currentCode === lastCode) {
        this.lessonDone = true;
      }
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
      // return "container-chinese-card-mobile"
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },

    funcRoute(val) {
      this.commitPayloadData(val);
    },
    commitPayloadData(path) {
      //for v4 planned ?
      //payload here
      const payload = {
        codeItem: this.v3Data.codeItem,
      };

      //commit add payload stack
      this.$store.commit('v4/addPayloadStack', payload);
      //var
      const currentDataStack = [...this.$store.state.v4.v4DataStack];
      const currentCodeItem = this.v3Data.codeItem;
      //get last code item form backend
      const lastCodeItem = this.v3Data.lastContent;
      //check store
      if (currentDataStack.length === 0) {
        //no dispatch if array empty
      } else {
        if (currentCodeItem === lastCodeItem) {
          this.$store.dispatch('v4/v4ProgressAndScoreCalc', {
            mainCodeItem: this.v3Data.mainCodeItem,
            mainType: this.v3Data.mainType,
            mainContent: this.v3Data.mainContent,
            dataStack: currentDataStack,
            pages: this.v3Data.pages,
            courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
            section: this.$store.state.v3.v3EnrollData.data.section,
          });
          this.nextPath = path;
        } else {
          console.log(path, 'else path');

          //onNext
          const str = path.split('-');
          const nextPath = `/v4/${str[0]}/${str[1]}`;
          this.$router.push(nextPath);
        }
        //if not just clear stack
      }
    },
  },
};
</script>
<style></style>
